import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Vite environment variables
const env = import.meta.env;

const requiredKeys = [
  'VITE_API_KEY',
  'VITE_AUTH_DOMAIN',
  'VITE_PROJECT_ID',
  'VITE_STORAGE_BUCKET',
  'VITE_MESSAGING_SENDER_ID',
  'VITE_APP_ID',
] as const;

const missingKeys = requiredKeys.filter((key) => !env[key]);
if (missingKeys.length > 0) {
  throw new Error(
    `Missing Firebase config keys in environment: ${missingKeys.join(', ')}`
  );
}

// Firebase configuration from Vite environment variables
const firebaseConfig = {
  apiKey: env.VITE_API_KEY,
  authDomain: env.VITE_AUTH_DOMAIN,
  projectId: env.VITE_PROJECT_ID,
  storageBucket: env.VITE_STORAGE_BUCKET,
  messagingSenderId: env.VITE_MESSAGING_SENDER_ID,
  appId: env.VITE_APP_ID,
};

// initialize firebase
const app = initializeApp(firebaseConfig);

// initialize auth with automatic React Native persistence
const auth = getAuth(app);

const firebaseDB = getFirestore(app);

export { auth };

export default firebaseDB;
